import Vue from 'vue';

import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';

import store from '../store';

const socket = io(process.env.VUE_APP_SOCKETIO_URL, { autoConnect: true });
Vue.use(VueSocketIOExt, socket, {
  store,
  actionPrefix: 'SOCKET_',
  eventToActionTransformer: (actionName) => actionName.toUpperCase(),
});

// store.dispatch('auth/PRE_LOGIN');
